export default {
  "welcome": "Welcome",
  "greeting": "Hello, {name}!",
  "about": "About Us",
  "contact": "Contact",
  "products": "Products",
  "cart": "Your Cart",
  "items": "items",

  // Navbar and common
  "home": "Home",
  "Solution": "Solution",
  "Focused": "Focused",
  "Technology": "Technology",
  "Efficiency": "Efficiency",
  "Scale": "Scale",
  "brand": "Innovative Pay",
  "language": "Language",

  // Homepage (hero)
  "hero": {
    "brand": "Innovative Pay",
    "titleLine2": "makes collecting payments",
    "titleLine3": "instant and hassle free",
    "desc": "Enable your business to accept digital payments instantly via an embedded solution fully integrated with major mobile wallets.",
    "emailPlaceholder": "Email address",
    "cta": "Start now >",
    "sending": "Sending…",
    "invalidEmail": "Invalid email format",
    "sent": "Sent successfully",
    "sendFailed": "Send failed, please try again later"
  },

  // HomePage1
  "hp1": {
    "titleLine1": "One checkout,",
    "titleLine2": "Every payment option",
    "kicker": "Accelerate Your Income",
    "headline1": "Monitor Transactions in Real-Time",
    "headline2": "",
    "bullet1": "Access a complete overview of every transaction with itemized revenue insights.",
    "bullet2": "Track all payments through a unified Real-Time Dashboard.",
    "goToSlide": "Go to slide",

    // Second slide
    "titleLine1_2": "One checkout,",
    "titleLine2_2": "Every payment option",
    "kicker_2": "Track All Transactions Accurately",
    "headline1_2a": "Fast & Protected Payments",
    "headline1_2b": "",
    "bullet1_2": "Process frictionless payments in just 3 steps with our express checkout.",
    "bullet2_2": "Maintain balanced, up-to-date payment metrics in a centralized hub.",

    // Third slide
    "titleLine1_3": "One checkout,",
    "titleLine2_3": "Every payment option",
    "kicker_3": "User-Centric Support",
    "headline1_3a": "Reliable Support When You Need It",
    "headline1_3b": "",
    "bullet1_3": "Rigorously tested to handle 50,000 transactions per second at peak load.",
    "bullet2_3": "Simulate thousands of scenarios in a responsive, intuitive interface.",

    // Fourth slide
    "titleLine1_4": "One checkout,",
    "titleLine2_4": "Every payment option",
    "kicker_4": "Accelerate Growth Seamlessly",
    "headline1_4a": "Efficient, User-Focused Payouts",
    "headline1_4b": "",
    "bullet1_4": "Enable customizable merchant settlements—seamless, transparent, and fee-free.",
    "bullet2_4": "Automated revenue reporting simplifies accrual accounting for precise book closure."
  },

  // HomePage2
  "hp2": {
    "bgAlt": "Background image",
    "supportSubtitle": "User-Centric Support",
    "supportTitle": "Reliable Support When You Need It",
    "supportDesc1": "Our 24/7 digital support hub resolves inquiries with speed and precision.",
    "supportDesc2": "Get instant assistance from our dedicated support team with one click.",
    "scalabilityTitle": "Unmatched Scalability",
    "stat1Number": "100 Million+",
    "stat1Desc": "Saved Payment Methods - Seamlessly store and manage your customers' preferred payment tools.",
    "stat2Number": "3.0000+",
    "stat2Desc": "High-Speed Processing - Capable of handling thousands of transactions per second.",
    "stat3Number": "10 Billion+",
    "stat3Desc": "Billions of transactions annually - trusted at scale by businesses of all sizes."
  },

  // HomePage3
  "hp3": {
    "mainTitle": "Payment Technology",
    "subtitle": "Trusted by Thousands of Merchants",
    "cta": "Why Choose the Innovaction Payment Gateway",
    "features": {
      "instantActivation": {
        "title": "Instant Activation",
        "desc": "Innovaction offers 100% online onboarding with minimal documentation, helping your business go live effortlessly."
      },
      "easyIntegration": {
        "title": "Easy Integration",
        "desc": "With Innovaction's powerful API and customizable SDK, you can start accepting digital payments in under 30 minutes—just a few lines of code is all it takes."
      },
      "multipleMethods": {
        "title": "Multiple Payment Methods",
        "desc": "Give your customers the flexibility to pay how they prefer, with support for debit and credit cards, online banking InX Wallet, and more."
      },
      "secureTransactions": {
        "title": "Industry-LeadingSuccess Rate",
        "desc": "Bank-level security with end-to-end encryption ensures your customers' data is always protected."
      },
      "support": {
        "title": "Industry-Leading Success Rates",
        "desc": "Thanks to intelligent routing and direct bank integrations, Innovaction's ensures your customers’payments are proce-ssed successfully-everytime."
      }
      ,
      "support1": {
        "title": "Pakistan's Most Popular Checkout Experience",
        "desc": "Over 100 million Pakistani choose Innovaction's Pay at checkout. Now you can offer your customers the seamless experience they know and love."
      }
      ,
      "support2": {
        "title": "Dedicated Support",
        "desc": "Every Innovaction's merchant and gateway user receives personalized assistan-ce via toll-free phone and email-at no additional cost."
      }
    }
  },

  // HomePage4
  "hp4": {
    "mainTitle": "Powerful Business Dashboard",
    "subtitle": "Easily manage and monitor your business performance.",
    "slides": {
      "analytics": {
        "title": "Real-time Analytics",
        "desc": "Access real-time analytics and customizable reports."
      },
      "collection": {
        "title": "Payment Collection",
        "desc": "Create payment links to collect payments effortlessly."
      },
      "dataIntegration": {
        "title": "Data Integration",
        "desc": "Seamless data integration and connectivity."
      }
    }
  },

  // HomePage5
  "hp5": {
    "mainHeading": "Data-Driven Insights For Smarter Decisions",
    "description1": "Get Free Access To Our Advanced Payment Analytics Module And Make Decisions Backed By Real-Time Data.",
    "features": {
      "benchmark": "Benchmark success rates across industries, platforms, and devices",
      "measure": "Measure performance of different payment sources",
      "understand": "Understand customer behavior and purchasing trends",
      "tailor": "Tailor your products and services to fit customer preferences"
    }
  },

  // HomePage6
  "hp6": {
    "title": "Our Clients",
    "prev": "Previous",
    "next": "Next",
    "illustrationAlt": "Clients illustration"
  },

  "footer": {
    "telephone": "Telephone number",
    "customerServiceEmail": "Customer service email",
    "copyright": "Copyright © Innovative Visionary Studios (Pvt) Ltd.",
    "backToTop": "Back to top"
  }
}
